import { Link } from 'react-router-dom';

/**
 * RECORDATORIO DE LIQUIDACIÓN SIN PAGO REGISTRADO (D-74, RN-124).
 *
 * QUÉ NO DEBE HACER NUNCA, y esta lista es normativa (RN-124h):
 *   1. NO bloquea nada.
 *   2. NO altera la deuda, el disponible, ningún saldo ni ningún total. Es TEXTO.
 *   3. NO impide volver a liquidar.
 *   4. NO ES UNA ALERTA y no se presenta como tal: nada de rojo, nada de signo de
 *      admiración, nada de modal, nada que interrumpa. Es un renglón informativo
 *      DEL MISMO PESO VISUAL que el aviso de cambio de fechas de la tarjeta.
 *   5. NO se repite plan por plan en las listas: ahí va solo una marca discreta.
 *   6. NO genera notificación de ningún tipo.
 *   7. NO TIENE BOTÓN DE "DESCARTAR" y no se guarda que se haya visto: la única
 *      forma de que desaparezca es que aparezca el dinero. Silenciarlo sería
 *      silenciar un saldo mal.
 *
 * EL TEXTO LO ESCRIBE EL SERVIDOR (RNF-038): aquí no se compara ningún importe y
 * no se redacta ninguna frase. La acción "Registrar el pago" solo se ofrece al
 * propietario, y además el dinero debe salir de una cuenta suya (RN-124i, RN-067).
 */
export function RecordatorioDePago({ recordatorio, idCuenta, esPropio = true }) {
  if (!recordatorio) return null;

  return (
    <div className="aviso i" data-prueba="recordatorio-de-pago">
      {recordatorio.texto}
      {esPropio && (
        <div style={{ marginTop: 8 }}>
          <Link
            className="btn sec"
            to={`/movimientos/traspaso?idCuentaDestino=${idCuenta}&importe=${recordatorio.importePendienteDeRegistrar}`}
          >
            Registrar el pago de la tarjeta
          </Link>
        </div>
      )}
      {!esPropio && (
        <span className="ayuda">
          Puedes verlo, pero <b>solo quien capturó el gasto puede registrar el pago</b>, y el dinero
          debe salir de una cuenta suya.
        </span>
      )}
    </div>
  );
}

/**
 * MARCA DISCRETA para el listado de planes y para la pestaña de MSI (RN-124b.3).
 * NUNCA el texto completo repetido plan por plan: repetir el mismo aviso en seis
 * renglones lo convierte en ruido y deja de leerse.
 */
export function MarcaDeRecordatorio({ visible }) {
  if (!visible) return null;

  return (
    <span
      className="chip"
      data-prueba="marca-de-recordatorio"
      aria-label="Hay una liquidación anticipada sin pago registrado en esta tarjeta"
      title="Hay una liquidación anticipada sin pago registrado en esta tarjeta"
    >
      ⓘ
    </span>
  );
}
